<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="">
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <base-button @click="addRow()" type="info">아티스트 추가</base-button>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <label class="col-form-label">ko</label>
            </div>
            <div class="col-sm-3">
              <label class="col-form-label">en</label>
            </div>
            <div class="col-sm-5">
              <label class="col-form-label">image</label>
            </div>
            <div class="col-sm-1"></div>
          </div>
          <hr />
          <draggable handle=".handle" v-model="artists" @start="drag = true" @end="drag = false">
            <div class="row" v-for="(item, index) in artists">
              <div class="col-sm-3">
                <base-input placeholder="ko" v-model="item.ko">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input placeholder="en" v-model="item.en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-5">
                <base-input placeholder="image" v-model="item.image">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-1 handle">
                <base-button @click="removeRow(index)" type="danger">-</base-button>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <base-button @click="addRow()" type="info">아티스트 추가</base-button>
          <base-button @click="onSubmit" type="success">등록</base-button>
          <base-button @click="clearCache()" type="danger">캐시초기화</base-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { BaseButton, BaseInput, Card } from "@/components/index";
import draggable from "vuedraggable";
import swal from "sweetalert2";

export default {
  components: {
    draggable,
    BaseInput,
    BaseButton,
  },
  async created() {
    await this.getArtists();
  },
  data() {
    return {
      artists: [],
    };
  },
  methods: {
    async getArtists() {
      return this.$axios.get(`/homepage/artists`).then((res) => {
        this.artists = res.data.data;
      });
    },
    addRow() {
      this.artists.push({});
    },
    removeRow(index) {
      this.artists.splice(index, 1);
    },

    async clearCache() {
      await this.$axios.post(`/homepage/invalidate`, this.lang);
      Toast.success("캐시가 초기화되었습니다");
    },
    async onSubmit() {
      swal
        .fire({
          title: "등록 확인",
          text: `등록 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            await this.$axios.post(`/homepage/artists`, { data: JSON.stringify(this.artists) });
            Toast.success("등록되었습니다");
          }
        });
    },
  },
};
</script>
